import { AppBar, Toolbar, Typography, Box, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import "./Navbar.scss";
import {
  listUser,
} from "../../../../Redux/Slices/User/ListUserSlice";
import { useAppDispatch, useAppSelector } from "../../../../Redux/Store/Hooks";
import UserProfileSection from "../../../../Components/UserProfileSection/UserProfileSection";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface NavbarProps {
  toggleSidebar?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ toggleSidebar }) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { data: menu_data } = useAppSelector((state) => state.SideMenuPermission);

  const pathname = location.pathname.toLowerCase().split('/').filter(Boolean).join('/');

  // Find the label from the menu data if possible
  const findTitle = (items: any[]): string | null => {
    for (const item of items) {
      if (!item.to) {
        if (item.items) {
          const title = findTitle(item.items);
          if (title) return title;
        }
        continue;
      }
      const itemPath = item.to.toLowerCase().split('/').filter(Boolean).join('/');
      if (itemPath === pathname || pathname.startsWith(itemPath + "/")) return item.title;
      if (item.items) {
        const title = findTitle(item.items);
        if (title) return title;
      }
    }
    return null;
  };

  const menuTitle = menu_data?.Dashboard ? findTitle(menu_data.Dashboard) : null;
  const displayHeading = menuTitle ??
    pathname.split('/').pop()?.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');


  useEffect(() => {
    dispatch(listUser());
  }, [dispatch]);

  return (
    <AppBar position="static" className="navbar">
      <Toolbar className="navbar-toolbar" sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <Box className="navbar-left" sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
          {toggleSidebar && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={toggleSidebar}
              className="mobile-menu-button"
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography variant="h6" className="navbar-title" sx={{ fontWeight: 600, color: "#4779ff" }}>
            {displayHeading}
          </Typography>
        </Box>

        <UserProfileSection />
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
